/**
 * FEEDBACK WIDGET — SELECTEUR DE TYPE (TICKET-CRM-14)
 * Deux boutons toggle bug / amélioration, contrôlés par le formulaire parent.
 */

import { cva } from 'class-variance-authority';
import { Bug, Sparkles } from 'lucide-react';
import type { FeedbackType } from '../../lib/feedback/feedback.types';

const feedbackTypeButtonVariants = cva(
  'flex items-center justify-center gap-2 rounded-md border p-3 text-sm transition-colors',
  {
    variants: {
      selected: {
        true: 'border-zinc-900 bg-zinc-900 text-white',
        false: 'border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50',
      },
      disabled: {
        true: 'cursor-not-allowed opacity-50',
        false: '',
      },
    },
    defaultVariants: {
      selected: false,
      disabled: false,
    },
  }
);

interface FeedbackTypeSelectorProps {
  value: FeedbackType;
  onChange: (value: FeedbackType) => void;
  disabled?: boolean;
}

const OPTIONS: Array<{ value: FeedbackType; label: string; icon: typeof Bug }> = [
  { value: 'bug', label: 'Signaler un bug', icon: Bug },
  { value: 'feature', label: 'Proposer une amélioration', icon: Sparkles },
];

export function FeedbackTypeSelector({ value, onChange, disabled }: FeedbackTypeSelectorProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {OPTIONS.map((option) => {
        const Icon = option.icon;
        const isSelected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className={feedbackTypeButtonVariants({
              selected: isSelected,
              disabled: Boolean(disabled),
            })}
          >
            <Icon className="h-4 w-4" />
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
